const tenderVersionIdsQueryParam = (url, versionIds) => {
  if (versionIds?.length) {
    let tenderVersionQuery = versionIds.map((elem) => `version_ids=${elem}`).join('&');
    return `${url}?${tenderVersionQuery}`;
  } else {
    return url;
  }
};

export default tenderVersionIdsQueryParam;
